<template>
    <section class="mt-16">
      <v-breadcrumbs
          v-if="this.$root.$vuetify.theme.isDark"
          large
          :items="crumbs"
          divider="/"
          light
          :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
        ></v-breadcrumbs>
        <v-breadcrumbs
          v-else
          :items="crumbs"
          divider="/"
          light
          :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
        ></v-breadcrumbs>
  
        <h1 class="primary--text">
          <v-icon color="primary">mdi-hard-hat</v-icon> <span>{{$t('supplier.crumb_edit')}}</span>
        </h1>
  
        <div class="mt-16" :style="this.$root.$vuetify.theme.isDark ? '' : 'background-color: rgba(255, 255, 255, 0.75) !important;'">
          <Edit method="update" :editCompany="company"></Edit>
        </div>
    </section>
  </template>
  <script>
  import Edit from '@/components/companies/Edit'
  import Company from '@/api/Company.js'
  
  export default {
    components: {
        Edit
    },
    beforeCreate(){
      document.title = "Report Lake - " + this.$t('supplier.crumb_edit');
    },
    data: () => ({
      company: null
    }),
    mounted(){
  
      if(!this.$root.session.hasPermission(["super", "companies.update"])) {
        this.$router.push('/admin');
      }

      Company.find(this.$route.params.id).then(({data}) => { this.company = data; this.loading = false;});
  
    },
    methods:{
      reload(){
        this.loading = true
        Company.find(this.$route.params.id).then(({data}) => { this.company = data; this.loading = false;});
      }
    },
    computed: {
      crumbs: function() {
        return [
          {
            text: this.$t('menu.dashboard'),
            disabled: false,
            to: '/' + this.$session.get('domain') + '/admin',
            exact: true,
          },
          {
            text: this.$t('menu.shopping'),
            disabled: false,
            to: '/' + this.$session.get('domain') + '/admin/shopping',
            exact: true,
          },
          {
            text: this.$t('supplier.crumb_edit'),
            disabled: true,
            to: window.location.href,
            exact: true,
          },
        ];
      }
    }
  };
  </script>
  